import React, { useEffect, useRef, useState } from 'react';
import CallPanel from '../call-panel/call-panel';
import { AudioElement } from '../../types/types';
import Loader from '../loader/loader';
import { getParameters } from '../../utils/utils';
import { JsSipController } from '../../controllers/jssip-controller';
import LogCollector from '../../controllers/log-collector';
import api from '../../controllers/api';

interface CallProps {
  sessionId: string;
  logCollector: LogCollector;
  inputDevice: string;
  outputDevice: string;
  setStarted: (value: boolean) => void;
  setIsError: (value: boolean) => void;
}

const Call = ({
  sessionId,
  logCollector,
  inputDevice,
  outputDevice,
  setStarted,
  setIsError,
}: CallProps) => {
  const remoteViewRef = useRef<AudioElement>(null);
  const [jsSipController, setJsSipController] = useState<JsSipController | null>(null);

  useEffect(() => {
    configure();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (jsSipController) {
      remoteViewRef.current && (jsSipController.remoteAudioElement = remoteViewRef.current);
    }
    // eslint-disable-next-line
  }, [
    jsSipController,
    remoteViewRef.current,
  ]);

  const configure = async () => {
    try {
      const config = await api.getConfiguration();

      if (!jsSipController) {
        setJsSipController(
          new JsSipController(
            sessionId,
            config,
            getParameters(),
            { inputDevice, outputDevice },
          )
        );
      }
    } catch (error) {
      setIsError(true);
      console.error("Ошибка при получении конфигурации", error);
      logCollector.sendLogs();
    }
  }

  if (jsSipController) {
    return (
      <>
        <CallPanel
          logCollector={logCollector}
          jsSipController={jsSipController}
          onEnd={() => setStarted(false)}
          setIsError={setIsError}
        />
        <audio
          ref={remoteViewRef}
          id="remote-audio"
          autoPlay
          controls={false}
          style={{ display: 'none' }}
        />
      </>
    );
  }

  return <Loader/>;
}

export default Call;